import 'angular:locale/data:en';
import 'angular:locale/data:uk';
import 'angular:locale/data:pl';
import './src/polyfills.ts';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
